import React, {useState, useEffect, useRef } from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
// import RichTextEditor from 'react-rte';
// import Select from "react-select";
// import { callPOST, callGET, callPUT } from '../../../Utils/ApiUtil';
import {fileNameShortenForDisplay,parameterizedURLAccessToken} from '../../../Utils/CommonFunctions';
import Icons from "../../../Components/Icons/Icons";
import RichTextEditor from 'react-rte';
// const RichTextEditor = React.lazy(() => import('react-rte'));

const ReplyToMail = (props) => {

	const uploadMultipleFiles = useRef();

	const fieldDetail = JSON.parse(props.formData);
	let bodyVal = fieldDetail.mail_body.value;
	let toVal= fieldDetail.mail_to.value;

	//console.log(props.files, 'props.files');
	//console.log(props.toUsers, 'props.toUsers');
	// console.log(props, 'fieldDetail')

	let isToUserMetaDataAvailable = false;
	if(props.toUsers) {
		props.toUsers.map((users,index) => {
			if(users.metatable_id) {
				if(users.metatable_id !== '') {
					isToUserMetaDataAvailable = true;
				}
			}
		})
	}

	if(props.composePage === 'main') {
		isToUserMetaDataAvailable = true;
	}

	let getToVal = '';
	getToVal = toVal.map((tomail,index) => {
		return tomail;
	});

	let suggestions = ''
	suggestions = props.suggestions.map((tomail,index) => {
		return (<li onClick={e => props.handleAddition(tomail)}>{tomail.email_field_display_name}({tomail.email_address})</li>);
	});

	let toUsers = '';
	toUsers = props.toUsers.map((users,index) => {
		let toTagCss = 'tag-wrapper ReactTags__tag';
		if(users.isValid === false){
			toTagCss = 'tag-wrapper ReactTags__tag_primary_bg';
		}
		return(<span className={toTagCss} style={{"opacity": "1", "cursor": "move"}} draggable="false">{users.field_display_name}<a className="ReactTags__remove" onClick={e=>props.handleDelete(index)}>×</a></span>)
	})

	let ccUsers = '';
	ccUsers = props.ccUsers.map((users,index) => {
		let ccTagCss = 'tag-wrapper ReactTags__tag';
		if(users.isValid === false){
			ccTagCss = 'tag-wrapper ReactTags__tag_primary_bg';
		}
		return(<span className={ccTagCss} style={{"opacity": "1", "cursor": "move"}} draggable="false">{users.email_address}<a className="ReactTags__remove" onClick={e=>props.handleDeleteccUSer(index)}>×</a></span>)
	})

	let bccUsers = '';
	bccUsers = props.bccUsers.map((users,index) => {
		let bccTagCss = 'tag-wrapper ReactTags__tag';
		if(users.isValid === false){
			bccTagCss = 'tag-wrapper ReactTags__tag_primary_bg';
		}
		return(<span className={bccTagCss} style={{"opacity": "1", "cursor": "move"}} draggable="false">{users.email_address}<a className="ReactTags__remove" onClick={e=>props.handleDeletebccUser(index)}>×</a></span>)
	})

	let templates = '';
	templates = props.mail_templates.map((item, index) => {
		return (<option value={item.value}>{item.name}</option>);

	})

	let tags = '';
	tags = props.windowTags.map((item, index) => {
		return (<option value={item.tag_id}>{item.tag_name}</option>);

	})

	let fromAdd = '';
	fromAdd = props.emailConfigList.map((item, index) => {
		return (<option confid={item.id} value={item.user_name}>{item.user_name}</option>);

	})


	// const textEditorValue = RichTextEditor.createEmptyValue();
	//const [textEditorValue, setTextEditorValue] = useState(RichTextEditor.createEmptyValue());
	const [textType,setTextType] = useState('markdown');
	const [textEditorValue, setTextEditorValue] = useState(RichTextEditor.createValueFromString(bodyVal, 'markdown'));


	useEffect( ()=>{
		// setTimeout( ()=>{ 
			let bodyVal = fieldDetail.mail_body.value;
			//console.log('bodyVal===reply mail',bodyVal);
      		setTextEditorValue(RichTextEditor.createValueFromString(bodyVal, 'html')) 
      		//console.log(bodyVal , 'bodyVallate')
		// }, 2000);
		
    }, [props.triggerEffect]);


	const onChangeHandler = (value) => {
		// console.log(value.toString('html'));
		setTextEditorValue(value);
		props.addDataTemplateBody(value.toString('markdown'));
		/*if (this.props.onChange) {
	      // Send the changes up to the parent component as an HTML string.
	      // This is here to demonstrate using `.toString()` but in a real app it
	      // would be better to avoid generating a string on each change.
	      this.props.onChange(
	        value.toString('html')
	      );
	    }*/
	}

	const submitHandler = () => {
		console.log(textEditorValue.toString('html'));
	}

	
    const onFileChange =()=>{
      // const totalFilesize = ((this.state.totalSize / (1024*1024)).toFixed(2));
      // if(totalFilesize>this.props.item.max){
      //   this.props.failMessage('Maximum file size reached');
      //   return false;
      // }else if(this.props.item.files.length>this.props.item.max){
      //   this.props.failMessage('Maximum '+this.props.item.max+' files only allowed');
      //   return false;
      // }                
      var inputField = uploadMultipleFiles;
      console.log(inputField);
      inputField.current.click();
    }

    const uploadMultipleFilesHandler = (e) => {
      //let updateFiles = this.state.files;
      props.uploadFileAPICall(e.target.files);
      
    }

 	const toolbarConfig = {
		// Optionally specify the groups to display (displayed in the order listed).
		display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
		INLINE_STYLE_BUTTONS: [
		  {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
		  {label: 'Italic', style: 'ITALIC'},
		  {label: 'Underline', style: 'UNDERLINE'}
		],
		BLOCK_TYPE_DROPDOWN: [
		  {label: 'Normal', style: 'unstyled'},
		  {label: 'Heading Large', style: 'header-one'},
		  {label: 'Heading Medium', style: 'header-two'},
		  {label: 'Heading Small', style: 'header-three'}
		],
		BLOCK_TYPE_BUTTONS: [
		  {label: 'UL', style: 'unordered-list-item'},
		  {label: 'OL', style: 'ordered-list-item'}
		]
	};

	// Custom overrides for "code" style.
	const styleMap = {
	  CODE: {
	    backgroundColor: '#f3f3f3',
	    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
	    fontSize: 16,
	    padding: 2,
	  },
	};

	const abcnd = (block) => {
		// console.log('ambdcndf',block);
	}

	const sendMail = () => {
			// let bodyCont = '';
			// if(textType === 'markdown'){
			// 	bodyCont = textEditorValue.toString("html");
			// }else{
			// 	bodyCont = textEditorValue.toString("html");	
			// }  		
  		//let bodyCont = textEditorValue.toString("html");

  		let bodyCont = '';
  		if(textType=="markdown"){
				bodyCont = textEditorValue.toString("html");			
			}else{			
				bodyCont = textEditorValue.toString("html").replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&');			
			}	
			// console.log(bodyCont,'bodyCont===');
			// return false;
			props.saveDataHandler(true,bodyCont);
	}

	return (
		<div className={props.modelOpen === true ? "email-sender p-2 align-items-start" : "hide"}>  
			<div className="avatar">
				<img src="/assets/img/profile2.jpg" alt="Avatar" />
			</div> 
			<div className="media-body">
				<div className="card">
					<div className="card-header">
					  	<div className="email-compose-fields p-0 border-0">
					  		
							<div className="form-group row mb-0">
								<label htmlFor="to" className="col-form-label col-md-1">To :</label>
								<div className="col-md-11">
								
									<div className="ReactTags__tags react-tags-wrapper" style={{"paddingRight":"75px"}}>
										<div className="ReactTags__selected">
										{toUsers}										
										<div className="ReactTags__tagInput">
											<input 
											class="ReactTags__tagInputField width_98_per" 
											type="text" 
											placeholder="Add Users List" 
											aria-label="Add Users List"											
											onChange={e=> props.searchUserHander(e)}
											onKeyDown={e => props.handleKeyDown(e)}
											value={props.toInputValue}
											/>
											{props.suggestions.length > 0 ?
											<div className="ReactTags__suggestions"><ul>{suggestions}</ul></div>	
											: 
											''
											}
											
										</div>
										</div>
									</div>

									{ /*<input type="text" className="form-control no-bd pl-0 newMail_custom" id="mail_to" name="mail_to" value={getToVal} onChange={e => props.addDataHandler(e)} />*/ }
									<a onClick={props.ccToggleHandler} className="icon-right third_light_color mr-3 cursor_pointer">Cc </a>
									<a onClick={props.bccToggleHandler} className="icon-right third_light_color mr-5 cursor_pointer">Bcc </a>
									{fieldDetail.mail_to.error !== "" ? 
		                            <label className="error m-0">{fieldDetail.mail_to.error}</label>
		                            : null
		                            }
								</div>
							</div>
							{
								props.ccShow === true ?
									<div className="" id="eCC">
										<div className="form-group row mb-0" id="eCC">
											<label htmlFor="cc" className="col-form-label col-md-1">Cc :</label>
											<div className="col-md-11">

												<div className="ReactTags__tags react-tags-wrapper">
													<div className="ReactTags__selected">
													{ccUsers}										
													<div className="ReactTags__tagInput">
														<input 
														class="ReactTags__tagInputField" 
														type="text" 
														placeholder="Add CC List" 
														aria-label="Add CC List"																									
														onChange={e => props.ccSearchUserHander(e)} 
														onKeyDown={e => props.ccHandleKeyDown(e)}
														value={props.ccInputValue}
														/>														
													</div>
													</div>
												</div>

												
											</div>
										</div>
									</div>
								: null
							}
							{
								props.bccShow === true ?
									<div className="" id="eCC">
										<div className="form-group row mb-0" id="eCC">
											<label htmlFor="cc" className="col-form-label col-md-1">Bcc :</label>
											<div className="col-md-11">

												<div className="ReactTags__tags react-tags-wrapper">
													<div className="ReactTags__selected">
													{bccUsers}										
													<div className="ReactTags__tagInput">
														<input 
														class="ReactTags__tagInputField" 
														type="text" 
														placeholder="Add BCC List" 
														aria-label="Add BCC List"																									
														onChange={e => props.bccSearchUserHander(e)} 
														onKeyDown={e => props.bccHandleKeyDown(e)}
														value={props.bccInputValue}
														/>														
													</div>
													</div>
												</div>

												
											</div>
										</div>
									</div>
								: null
							}
							{/*<div className="form-group row mb-0">
								<label htmlFor="subject" className="col-form-label col-md-1">Subject :</label>
								<div className="col-md-11">
									<input type="text" className="form-control no-bd pl-0" id="subject" name="subject" style={{"border-bottom": "1px solid #ced4da !important"}} value="New Sign-in to your Zoho accountq" />
								</div>
							</div>*/}
						</div>  
					</div>

				<div className="card-body p-0">
					<div className="email-editor">
						{
							isToUserMetaDataAvailable ? 
							<Wrp>
							<div className="btn-group">
								<a onClick={onFileChange} className="btn btn-border btn-default"  title="Attach file from local"> 
									<Icons iconType="Attachments" />
								</a>
			 
								{/*<a onClick={props.tableModalHandler} className="btn btn-border btn-default"  title="Attach PDF"> 
									<Icons iconType="PDF" />
								</a>

								<a onClick={props.attachInternalCSV} className="btn btn-border btn-default"  title="Attach CSV"> 
									<Icons iconType="CSV" />
								</a>*/}
								<input id="fileInput" accept="*" ref={uploadMultipleFiles} type="file" multiple style={{display:'none'}}  onChange={uploadMultipleFilesHandler}  />
							</div>
							<div className="email-attachments d-flex justify-content-between">
							<div className="form-group ">
								<label className="col-form-label border-bottom mb-0"> Local Attachments <span>({props.files.length} files)</span> </label>
								<ul>
									{
										props.files.map((itemFile,index)=>{
											let imagePath = '/assets/img/noimage.png';
					                      	if(itemFile.id!==''){
					                        	imagePath = parameterizedURLAccessToken('files/download?fileId='+itemFile.id)
					                      	}
					                      	const itemFileLabel = fileNameShortenForDisplay(itemFile.label);
					                      	const itemSize = itemFile.size;
					                      	return(
					                      		<li key={index+'wrp'}>																			                      		
					                      			<a href="#">{itemFileLabel} <span>({itemSize} KB)</span></a>
					                      			<span>&nbsp;</span>
					                      			<small onClick={e=>props.removeAddedFile(index)}><i className="far fa-trash-alt fa-lg cursor-pointer"></i></small>								                        								                      							                      
					                      		</li>
					                      	)	
										})
									}
									
								</ul>
							</div>

							{/*<div className="form-group ">
								<label className="col-form-label border-bottom mb-0"> PDF and CSV Templates <span>({props.filesInternal.length} files)</span> </label>
								<ul>
									{
										props.filesInternal.map((itemFile,index)=>{
											let imagePath = '/assets/img/noimage.png';
                    	if(itemFile.id!==''){
                      	imagePath = parameterizedURLAccessToken('files/download?fileId='+itemFile.id)
                    	}
                    	const itemFileLabel = fileNameShortenForDisplay(itemFile.label);
                    	const itemSize = itemFile.size;
                    	return(
                    		<li key={index+'wrp'}>																			                      		
                    			<a href="#">{itemFileLabel} <span>({itemSize} KB)</span></a>
                    			<span>&nbsp;</span>
                    			<small onClick={e=>props.removeAddedFileInternal(index)}><i className="far fa-trash-alt fa-lg cursor-pointer"></i></small>								                        								                      							                      
                    		</li>
                    	)	
										})
									}
									
								</ul>
							</div>*/}

						</div>
							</Wrp>
							: null
						}

						<RichTextEditor
					        value={textEditorValue}
					        onChange={onChangeHandler}
					        toolbarConfig={toolbarConfig}
					        placeholder="Click here to reply"
					        editorClassName="texteditor_height"
					        toolbarClassName = "ddddddddddddd"
					        customStyleMap={{marginRight: '5000px'}}
					        className=""
					        blockStyleFn={abcnd}
					      /> 
					</div>

				</div>

					<div className="card-footer">
						 <div className="d-flex align-items-center justify-content-between">
						 	<div className=""> 
							<a onClick={sendMail} className="btn primary_bg"> Send </a>
							<a onClick={props.toggleReplyToWindow} className="btn border-default btn-border mr-2">Cancel</a>
						 	</div>

						 	<div className=""> 
						 		<div className="icons">
								<a onClick={props.toggleReplyToWindow} className="cursor-pointer">
									<Icons iconType="MailDeleteIcon" />
								</a>
							</div>
						 	</div>
						 </div>
					</div>
				</div>
				
			</div>
		</div>
	)
}

export default ReplyToMail;